export default __webpack_public_path__ + "static/media/save-icon-teal.207d2e5d.svg";